import { Field } from 'formik';
import { FormControl, Stack, Switch, HStack, VStack, Box } from '@chakra-ui/react';
import FormLabel from 'components/v4/FormLabel';
import { formLabelStyling, stackStyling, stackSpacing } from 'components/forms/new/formStyles';

export default function InternationalRateStatusField({ darkMode }) {
return (
    <FormControl sx={{ margin: '0 !important' }}>
        <Stack direction="row" spacing={stackSpacing} sx={{ ...stackStyling(true), height: '65px' }}>
            <FormLabel sx={formLabelStyling(darkMode)} minW="120px">
                Status
            </FormLabel>
            <Box flex="1" minWidth="450px">
                <VStack width="100%" alignItems="normal" marginTop="15px">
                    <HStack spacing={6}>
                        <Field name="isPublic">
                            {({ field, form }) => (
                                <HStack spacing={3} alignItems="center">
                                    <Switch
                                        isChecked={field.value}
                                        onChange={(e) => form.setFieldValue('isPublic', e.target.checked)}
                                        name="isPublic"
                                        colorScheme="whatsapp"
                                    />
                                    <FormLabel sx={{ marginBottom: '6px !important' }} fontSize="sm" display="flex" alignItems="center">
                                        Public
                                    </FormLabel>
                                </HStack>
                            )}
                        </Field>
                        <Field name="isActive">
                            {({ field, form }) => (
                                <HStack spacing={3} alignItems="center">
                                    <Switch
                                        isChecked={field.value}
                                        onChange={(e) => form.setFieldValue('isActive', e.target.checked)}
                                        name="isActive"
                                        colorScheme="whatsapp"
                                    />
                                    <FormLabel sx={{ marginBottom: '6px !important' }} fontSize="sm" display="flex" alignItems="center">
                                        Active
                                    </FormLabel>
                                </HStack>
                            )}
                        </Field>
                    </HStack>
                </VStack>
            </Box>
        </Stack>
    </FormControl>
);
}
